import Icon from './icon'
import Input from './input'
import InputLabel from './input-label'
import Clearfix from './clearfix'
import createValidateComponent from './redux-form-validate'

export { Icon, Input, InputLabel, Clearfix, createValidateComponent }

export default {
  Icon,
  Input,
  InputLabel,
  Clearfix,
  createValidateComponent
}



// WEBPACK FOOTER //
// ./src/components/elements/index.js